<template>
    <BRow class="mt-2">
        <BCol md="6" lg="6">
            <BFormGroup :label="nameLabel" label-for="workflow-supplier-name">
                <BFormInput
                    id="workflow-supplier-name"
                    class="input-bg-warning"
                    :value="name"
                    @input="$emit('update:name', $event)"
                />
            </BFormGroup>
            <BFormGroup :label="identifierLabel" label-for="workflow-supplier-identifier">
                <BFormInput
                    id="workflow-supplier-identifier"
                    :value="identifier"
                    @input="$emit('update:identifier', $event)"
                />
            </BFormGroup>
            <BFormGroup :label="scipNumberLabel" label-for="workflow-supplier-scip-number">
                <BFormInput
                    id="workflow-supplier-scip-number"
                    :value="scipNumber"
                    @input="$emit('update:scip-number', $event)"
                />
            </BFormGroup>
        </BCol>
    </BRow>
</template>

<script>
import {
    BCol,
    BFormGroup,
    BFormInput,
    BRow,
} from 'bootstrap-vue'

export default {
    name: 'WorkflowSupplierDetailsSection',
    components: {
        BCol,
        BFormGroup,
        BFormInput,
        BRow,
    },
    props: {
        name: { type: String, default: '' },
        identifier: { type: String, default: '' },
        scipNumber: { type: String, default: '' },
        nameLabel: { type: String, required: true },
        identifierLabel: { type: String, required: true },
        scipNumberLabel: { type: String, required: true },
    },
}
</script>
